"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Component", {
  enumerable: true,
  get: function get() {
    return _programCard.default;
  }
});
Object.defineProperty(exports, "bootstrapWidget", {
  enumerable: true,
  get: function get() {
    return _actions.bootstrapWidget;
  }
});
Object.defineProperty(exports, "container", {
  enumerable: true,
  get: function get() {
    return _programCard2.default;
  }
});
Object.defineProperty(exports, "getProgramFromMarketplace", {
  enumerable: true,
  get: function get() {
    return _actions.getProgramFromMarketplace;
  }
});
Object.defineProperty(exports, "reducer", {
  enumerable: true,
  get: function get() {
    return _reducer.default;
  }
});

var _programCard = _interopRequireDefault(require("./components/program-card/program-card"));

var _programCard2 = _interopRequireDefault(require("./containers/program-card"));

var _reducer = _interopRequireDefault(require("./lib/reducer"));

var _actions = require("./lib/actions");
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy9pbmRleC5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQUFBOztBQUNBOztBQUNBOztBQUNBIiwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IHsgZGVmYXVsdCBhcyBDb21wb25lbnQgfSBmcm9tICcuL2NvbXBvbmVudHMvcHJvZ3JhbS1jYXJkL3Byb2dyYW0tY2FyZCc7XG5leHBvcnQgeyBkZWZhdWx0IGFzIGNvbnRhaW5lciB9IGZyb20gJy4vY29udGFpbmVycy9wcm9ncmFtLWNhcmQnO1xuZXhwb3J0IHsgZGVmYXVsdCBhcyByZWR1Y2VyIH0gZnJvbSAnLi9saWIvcmVkdWNlcic7XG5leHBvcnQgeyBib290c3RyYXBXaWRnZXQsIGdldFByb2dyYW1Gcm9tTWFya2V0cGxhY2UgfSBmcm9tICcuL2xpYi9hY3Rpb25zJztcbiJdfQ==